import { cn } from "../../utils/lib";

const Text = ({
    text,
    className,
    children,
    onClick,
}: {
    text?: string | number;
    className?: string;
    children?: React.ReactNode;
    onClick?: () => void;
}) => {
    return (
        <div className={cn("max-w-60 truncate", className)} onClick={onClick}>{children || text}</div>
    );
};

export { Text };

